import { GenericError } from '@auth0/auth0-spa-js';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function exhaustiveCheck(param: never) {}

export function isExpiredAuth0RefreshTokenError(error: Error) {
  return error instanceof GenericError && (error.error === 'invalid_grant' || error.error === 'missing_refresh_token');
}
